import { requestLogin } from "../../../redux/slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hook";
import { unwrapResult } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { Form, Input, Button, Checkbox, Row } from "antd";
import { LockFilled, MailFilled } from "@ant-design/icons";
import background from "../../../assets/background-login.png";
import { useNavigate } from "react-router";
import { AppResource } from "../../../assets/AppResource";

export const LoginScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const authState = useAppSelector((state) => state.authState);
  const handleLogin = async (data) => {
    try {
      const result = await dispatch(
        requestLogin({
          username: data.username,
          password: data.password,
        })
      );
      const res = unwrapResult(result);
      const userInfo = res.data;
      const isLoggedIn = res.error;
      if (!isLoggedIn) {
        if (userInfo.role.includes("ROLE_ADMIN")) {
          navigate("/");
        }
      }
      Cookies.set("x-access-token", JSON.stringify(res.data.token));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="flex w-full">
      {/* <div className="w-1/2 h-screen flex items-center justify-center">
        <img
          src={background}
          alt="background"
          className="max-h-full max-w-full"
        />
      </div> */}

      <div className="w-full p-4 flex flex-col items-center justify-center h-screen">
        <div className="max-h-100 flex flex-col">
          <img
            src={AppResource.logo}
            alt="logo"
            className="mb-4 self-center"
            style={{
              aspectRatio: 1,
              width: 120,
            }}
          />
          <b className="text-2xl">Đăng nhập</b>
          <Form
            initialValues={{ remember: true }}
            onFinish={handleLogin}
            autoComplete="off"
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input
                placeholder="Tài khoản"
                prefix={<MailFilled />}
                className="w-80 p-2 border rounded-xl mt-4"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password
                placeholder="Mật khẩu"
                prefix={<LockFilled />}
                className="w-80 border rounded-xl"
              />
            </Form.Item>
            <Row>
              <Checkbox>Ghi nhớ đăng nhập</Checkbox>
              <a className="text-main font-bold ml-12">Quên mật khẩu?</a>
            </Row>
            <Form.Item>
              <Button
                htmlType="submit"
                className="w-80 h-10 hover:bg-white text-white font-extrabold border rounded-xl mt-4"
              >
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
